import { useGLTF } from '@react-three/drei'

export default function Cone({ ...props }) {
  const { nodes, materials } = useGLTF('https://res.cloudinary.com/dvr397xda/image/upload/v1656599264/cube/museum/cone-transformed-v1_f1u06m.glb')
  return <mesh dispose={null} castShadow geometry={nodes.Aset_other__M_uhrhabqfa_LOD0.geometry} material={materials.DefaultMaterial} {...props} />
}

// useGLTF.preload('https://res.cloudinary.com/dvr397xda/image/upload/v1656599264/cube/museum/cone-transformed-v1_f1u06m.glb')
